import { Check, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';

const Rooms = () => {
  const rooms = [
  {
    id: 'deluxe',
    name: 'Deluxe Room',
    description: 'A cozy retreat with modern amenities and serene views.',
    image: '/images/pic_1.jpeg',
    features: [
      'Air Conditioned',
      'Attached Bathroom',
      'Clean & Comfortable',
      'Room Service'
    ],
  },
  {
    id: 'garden-view',
    name: 'Garden View Room',
    description: 'Wake up to lush greenery and the sounds of nature.',
    image: '/images/pic_4.jpeg',
    features: [
      'Garden View',
      'Air Conditioned',
      'Attached Bathroom',
      'Private Balcony'
    ],
  },
  {
    id: 'family',
    name: 'Family Room',
    description: 'Spacious accommodation perfect for families and groups.',
    image: '/images/pic_8.jpeg',
    features: [
      'Extra Space',
      'Air Conditioned',
      'Attached Bathroom',
      'Up to 4 Guests'
    ],
  },
];
  return (
    <section
      id="rooms"
      data-testid="rooms-section"
      className="py-24 md:py-32 bg-[#F9F9F7]"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <p className="font-sans text-sm tracking-[0.3em] uppercase text-jungle-500 mb-4">
            Accommodations
          </p>
          <h2
            data-testid="rooms-title"
            className="font-serif text-3xl md:text-5xl text-jungle-800 mb-6"
          >
            Our Rooms
          </h2>
          <div className="w-20 h-0.5 bg-earth-400 mx-auto" />
        </div>

        {/* Room Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {rooms.map((room, index) => (
            <div
              key={room.id}
              data-testid={`room-card-${room.id}`}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Room Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={room.image}
                  alt={room.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-jungle-900/60 to-transparent" />
                <h3 className="absolute bottom-4 left-4 font-serif text-2xl text-white">
                  {room.name}
                </h3>
              </div>

              {/* Room Content */}
              <div className="p-6">
                <p className="text-jungle-600 mb-6 leading-relaxed">
                  {room.description}
                </p>

                {/* Features */}
                <ul className="space-y-2 mb-6">
                  {room.features.map((feature) => (
                    <li
                      key={feature}
                      className="flex items-center gap-2 text-jungle-700 text-sm"
                    >
                      <Check className="w-4 h-4 text-earth-500 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <Button
                  data-testid={`room-book-${room.id}`}
                  onClick={() => window.open('tel:+919256930540')}
                  className="w-full bg-jungle-800 hover:bg-jungle-700 text-white rounded-full flex items-center justify-center gap-2 py-5"
                >
                  <Phone className="w-4 h-4" />
                  <span>Book Now</span>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Rooms;
